import { Check } from "lucide-react";
import { WHO_CHECKLIST } from "../config/brand";
import { FadeUp, LineReveal } from "../components/Reveal";

export const WhoItsFor = () => (
  <section className="bg-blushcream/60" aria-label="Who it's for" data-testid="who-its-for-section">
    <div className="mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-12 px-5 py-20 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:py-28">
      <FadeUp className="order-2 lg:order-1 lg:col-span-5">
        <div className="overflow-hidden rounded-3xl border border-mauve/30 shadow-[0_24px_60px_rgba(90,48,73,0.14)]">
          <img
            src="/assets/play.png"
            alt="A mother doing a simple craft activity with her daughter on the living room floor"
            className="aspect-[4/5] w-full object-cover"
            width={760}
            height={950}
            loading="lazy"
          />
        </div>
      </FadeUp>
      <div className="order-1 lg:order-2 lg:col-span-7">
        <LineReveal
          as="h2"
          lines={["For the woman who wants more—", "but doesn't have unlimited time."]}
          className="font-serif text-4xl font-medium leading-[1.08] tracking-tight text-plum sm:text-5xl"
        />
        <FadeUp delay={0.15}>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-plumcharcoal/75 sm:text-lg">
            This system is for you if…
          </p>
        </FadeUp>
        <ul className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {WHO_CHECKLIST.map((item, i) => (
            <FadeUp key={item} delay={0.2 + i * 0.04}>
              <li
                data-testid={`who-check-${i + 1}`}
                className="flex h-full items-start gap-3 rounded-2xl border border-mauve/35 bg-warmwhite p-5 text-sm leading-relaxed text-plumcharcoal/80"
              >
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-plum text-ivory">
                  <Check size={13} strokeWidth={2.5} />
                </span>
                {item}
              </li>
            </FadeUp>
          ))}
        </ul>
        <FadeUp delay={0.45}>
          <p className="mt-8 font-serif text-2xl italic leading-snug text-plum">
            You don't need to reinvent your life. You need tools that work
            with it.
          </p>
        </FadeUp>
      </div>
    </div>
  </section>
);
